export default __webpack_public_path__ + "static/media/flag-3.ca5c51b0.gif";